import { SHOW_MODAL, HIDE_MODAL } from '../constants/action-types';

export const showModal = (modalProps, modalType) => ({
  type: SHOW_MODAL,
  modalProps,
  modalType,
});

export const hideModal = resetAction => ({
  type: HIDE_MODAL,
  resetAction,
});
